import { render, staticRenderFns } from "./onboardingCompanyUsersComponent.vue?vue&type=template&id=65ea991d&"
import script from "./onboardingCompanyUsersComponent.vue?vue&type=script&lang=js&"
export * from "./onboardingCompanyUsersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports